import React from 'react';
import PropTypes from 'prop-types';

import styles from './CenteredOnDecimal.css';

const CenteredOnDecimal = ({ children }) => {
    if (!/\d\.\d/.test(children)) return children;
    const [whole, decimals] = children.toString().split('.');
    return (
        <span className="centered-on-decimal">
            <span className="whole-number">{whole}</span>
            <span className="decimal-number">.{decimals}</span>
            <style jsx>{styles}</style>
        </span>
    );
};

CenteredOnDecimal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default CenteredOnDecimal;
